module.exports = __webpack_public_path__ + "img/salma-mehboob.14411c4c.jpg";